<template>
<form ref="form">
	<div style="display:grid; grid-template-columns: repeat(9, 1fr); text-align:center">
		<div>
			<input-quantity :max="10" />
			<p style="line-height:100%">
				Coin Flip
			</p>
		</div>
		<div>
			<input-quantity :max="10" />
			<span>d4</span>
		</div>
		<div>
			<input-quantity :max="10" />
			<span>d6</span>
		</div>
		<div>
			<input-quantity :max="10" />
			<span>d8</span>
		</div>
		<div>
			<input-quantity :max="10" />
			<span>d10</span>
		</div>
		<div>
			<input-quantity :max="10" />
			<span>d12</span>
		</div>
		<div>
			<input-quantity :max="10" />
			<span>d20</span>
		</div>
		<div>
			<input-quantity :max="100" />
			<span>+</span>
		</div>
		<button class="submit"
			@click.prevent="reset"
		>
			Reset
		</button>
	</div>
	<div class="roll-config relative">
		<div
			v-if="!account.props.sub"
			class="subscriber-lockout-modal"
		>
			<h3><a>Subscribe</a> to unlock coin flip animations</h3>
		</div>
		<p>Coin Flip Animation</p>
		<select v-model="coinFlipSkin">
			<option :value="false" selected>
				None
			</option>
			<option v-if="account.props.sub" value="DEFAULT">
				Default
				<!--<img src="https://img.rphaven.com/default-coin-preview.svg" style="height:70px;" />-->
			</option>
			<option v-if="account.priv.perks[ perks.GYATE_FOX_COIN_SKIN.id ]" value="GYATE_FOX_COIN_SKIN">
				Gyate Gyate Fox
				<!--<img src="https://img.rphaven.com/gyate-fox-coin-preview.svg" style="height:70px;" />-->
			</option>
		</select>
	</div>
	<button class="submit" style="position:absolute; bottom:3px; right:3px"
		@click.prevent="submitRoll"
	>
		Roll
	</button>
</form>
</template>

<script>
import perks from '../json/shared/perks.json'
import socket from '../js/socket.js'
import $ from 'jquery'
import inputQuantityVue from './input-quantity.vue'

export default {
	components: {
		inputQuantity: inputQuantityVue
	},
	props: {
		account: {
			type: Object,
			required: true
		},
		roomname: {
			type: [String, Boolean],
			default: false
		},
		toid: {
			type: Number,
			default: 0
		},
		msgid: {
			type: Number,
			default: 0
		},
		userid: {
			type: Number,
			default: 0
		}
	},
	data: () => ({
		perks: perks,
		coinFlipSkin: false
	}),
	methods: {
		submitRoll(){
			const dice = [2, 4, 6, 8, 10, 12, 20, 'add'],
				rolls = [],
				inputs = Array.from( this.$refs.form.querySelectorAll( 'input[type="number"]' ) )

			inputs.forEach( ( input, i ) => {
				rolls.push( [dice[i], parseInt( input.value )] )
			})

			console.log( this, 'roll...', {
				animate: this.coinFlipSkin,
				rolls: rolls,
				roomname: this.roomname,
				msgid: this.msgid,
				toid: this.toid,
				userid: this.userid
			})
			socket.emit( 'roll',
				{
					animate: this.coinFlipSkin,
					rolls: rolls,
					roomname: this.roomname,
					msgid: this.msgid,
					toid: this.toid,
					userid: this.userid
				}
			)
			$( this.$refs.form ).closest( '.ui-dialog' ).find( '.ui-dialog-titlebar-close' ).click()
		},
		reset( ev ){
			const inputs = Array.from( this.$refs.form.getElementsByTagName( 'input' ) )
			inputs.forEach( ( input ) => {
				input.value = input.getAttribute( 'min' )
			})
		}
	}
}
</script>